const SET_TAB_DETAIL = 'SET_TAB_DETAIL'
const SET_FILTER_DETAIL = 'SET_FILTER_DETAIL'

export { SET_TAB_DETAIL, SET_FILTER_DETAIL }
